import clsx from 'clsx'
import React from 'react'
import style from './legends.module.css'

const Legend = ({ tagName = 'b', children, useMargin, ...rest }) => {
    return React.createElement(
        tagName,
        { className: clsx(style.root, useMargin && style.margin), ...rest },
        children,
    )
}

export default Legend
